import { REPORTSUMMARYUSERS_SUCCESS, REPORTSUMMARYUSERS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYUSERS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYUSERS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default reportSummaryUsersReducer;
